'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = ComponentList;

var _ReduxComponent2 = require('redux-components/lib/ReduxComponent');

var _ReduxComponent3 = _interopRequireDefault(_ReduxComponent2);

var _withSubtree = require('redux-components/lib/decorators/withSubtree');

var _withSubtree2 = _interopRequireDefault(_withSubtree);

var _action = require('redux-components/lib/decorators/action');

var _action2 = _interopRequireDefault(_action);

var _selector = require('redux-components/lib/decorators/selector');

var _selector2 = _interopRequireDefault(_selector);

var _reduxComponentsMap = require('redux-components-map');

var _reduxComponentsMap2 = _interopRequireDefault(_reduxComponentsMap);

var _cuid = require('cuid');

var _cuid2 = _interopRequireDefault(_cuid);

var _createBehaviorSubject = require('observable-utils/lib/createBehaviorSubject');

var _createBehaviorSubject2 = _interopRequireDefault(_createBehaviorSubject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function ComponentList(typeMap) {
  var _class, _temp, _dec, _dec2, _dec3, _desc, _value, _class2;

  // Support objects as typemaps
  if (typeof typeMap !== 'function') {
    var typeMapObject = typeMap;
    typeMap = function typeMap(key) {
      return typeMapObject[key];
    };
  }
  var ComponentMapClass = (0, _reduxComponentsMap2.default)(typeMap);

  return (0, _withSubtree2.default)(function () {
    return {
      _map: ComponentMapClass
    };
  })((_temp = _class = (_dec = (0, _action2.default)({ isDispatcher: true }), _dec2 = (0, _action2.default)({ isDispatcher: true }), _dec3 = (0, _selector2.default)({ isObservable: true }), (_class2 = function (_ReduxComponent) {
    (0, _inherits3.default)(ComponentList, _ReduxComponent);

    function ComponentList() {
      (0, _classCallCheck3.default)(this, ComponentList);

      // toArray observable
      // TODO: clean this up somehow
      var _this = (0, _possibleConstructorReturn3.default)(this, (ComponentList.__proto__ || (0, _getPrototypeOf2.default)(ComponentList)).call(this));

      var subj = (0, _createBehaviorSubject2.default)();
      _this._internalList.subscribe({
        next: function next() {
          return subj.next(_this.toArray());
        }
      });
      var myToArray = _this.toArray;
      var nextToArray = function nextToArray() {
        return myToArray.call(this);
      };
      (0, _assign2.default)(nextToArray, subj);
      _this.toArray = nextToArray;
      return _this;
    }

    (0, _createClass3.default)(ComponentList, [{
      key: 'reducer',
      value: function reducer(state, action) {
        // Initial state
        if (!state.list) state = (0, _assign2.default)({}, state, { list: [] });
        switch (action.type) {
          case this.INTERNAL_SPLICE:
            var nextArray = state.list.slice();
            nextArray.splice.apply(nextArray, (0, _toConsumableArray3.default)(action.payload));
            return (0, _assign2.default)({}, state, { list: nextArray });
          default:
            return state;
        }
      }
    }, {
      key: '_internalAdd',
      value: function _internalAdd(index) {
        for (var _len = arguments.length, additions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          additions[_key - 1] = arguments[_key];
        }

        return {
          type: this.INTERNAL_SPLICE,
          payload: [index, 0].concat(additions)
        };
      }
    }, {
      key: '_internalRemove',
      value: function _internalRemove(index, n) {
        return {
          type: this.INTERNAL_SPLICE,
          payload: [index, n]
        };
      }
    }, {
      key: '_internalList',
      value: function _internalList(state) {
        return state.list || [];
      }

      // API: get(i)
      // Get the i'th entry in the list

    }, {
      key: 'get',
      value: function get(i) {
        var list = this.state.list;
        if (!list) return undefined;
        if (i >= 0 && i < list.length) return this._map.get(list[i]);
      }

      // API: toArray()
      // Convert to a plain JS array of ReduxComponents

    }, {
      key: 'toArray',
      value: function toArray() {
        return this.map(function (x) {
          return x;
        });
      }

      // API: splice(index, howmany, ...descriptors)
      // As `array.splice` but does not take negative indices or return
      // removed entities.

    }, {
      key: 'splice',
      value: function splice(index, howmany) {
        for (var _len2 = arguments.length, descriptors = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          descriptors[_key2 - 2] = arguments[_key2];
        }

        var _this2 = this;

        if (index < 0) throw new Error("ComponentList.splice: positive indices only");
        var list = this.state.list;

        var removals = null;
        if (howmany > 0) {
          removals = list.slice(index, index + howmany);
          // Remove from local array first
          this._internalRemove(index, howmany);
          // Unmount from map
          removals.forEach(function (id) {
            return _this2._map.remove(id);
          });
        }

        if (descriptors.length > 0) {
          // Add to map first
          var ids = descriptors.map(function () {
            return (0, _cuid2.default)();
          });
          ids.forEach(function (id, idx) {
            return _this2._map.add(id, descriptors[idx]);
          });
          // Then add to local array
          this._internalAdd.apply(this, [index].concat((0, _toConsumableArray3.default)(ids)));
        }
      }
    }, {
      key: 'push',


      // API: push(...descriptors)
      // Add a new component with the given descriptor to the end of the list
      value: function push() {
        for (var _len3 = arguments.length, descriptors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          descriptors[_key3] = arguments[_key3];
        }

        this.splice.apply(this, [this.length, 0].concat(descriptors));
      }

      // API: unshift(...descriptors)
      // Add a new component with the given descriptor to the beginning of the list

    }, {
      key: 'unshift',
      value: function unshift() {
        for (var _len4 = arguments.length, descriptors = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          descriptors[_key4] = arguments[_key4];
        }

        this.splice.apply(this, [0, 0].concat(descriptors));
      }

      // API: forEach(callback, thisArg)

    }, {
      key: 'forEach',
      value: function forEach(callback, thisArg) {
        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this.get(i), i, this);
        }
      }

      // API: map(callback, thisArg)

    }, {
      key: 'map',
      value: function map(callback, thisArg) {
        var result = [];
        var state = this.state;
        if (!state || !state.list) return result;
        var list = state.list;
        for (var i = 0; i < list.length; i++) {
          result.push(callback.call(thisArg, this._map.get(list[i]), i, this));
        }return result;
      }
    }, {
      key: 'length',
      get: function get() {
        var state = this.state;
        if (!state) return 0;
        return state.list.length;
      }
    }]);
    return ComponentList;
  }(_ReduxComponent3.default), (_applyDecoratedDescriptor(_class2.prototype, '_internalAdd', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_internalAdd'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_internalRemove', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_internalRemove'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_internalList', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_internalList'), _class2.prototype)), _class2)), _class.verbs = ['INTERNAL_SPLICE'], _temp)); // class ComponentList
}